/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TemplatesResponse } from '../../models/templates-response';

export interface TemplateGetAll$Params {
  'Active-Tenant-Identifier': string;
  templateType: 'opts-config' | 'tender-config' | 'order-charge-limits' | 'pos-status-notifications';
}

export function templateGetAll(http: HttpClient, rootUrl: string, params: TemplateGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplatesResponse>> {
  const rb = new RequestBuilder(rootUrl, templateGetAll.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateType', params.templateType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplatesResponse>;
    })
  );
}

templateGetAll.PATH = '/ordering/templates/{templateType}';
